export const agentColorDetailsSelector = state => state.agentColourReducer.agentColorDetails;
export const agentColorThemesSelector = state => state.agentColourReducer.agentColorThemes;
